import { memo } from 'react'
import { NavigateFunction } from 'react-router-dom'
import { ConfigOptions } from 'config/config.interface'
import Page from 'containers/Page'
import ErrorFallback from 'containers/ErrorFallback'

interface RouteElementProps {
  options: ConfigOptions | undefined
  navigate: NavigateFunction
}

const RouteElement = memo(({ options, navigate }: RouteElementProps) => {
  if (!options) {
    return <ErrorFallback />
  }

  return <Page navigate={navigate} options={options} />
})

RouteElement.displayName = 'RouteElement'

export default RouteElement
